import React, { createContext, useContext, useRef } from "react";
import PropTypes from "prop-types";

const VideoElementRefContext = createContext({
  current: null
});

export const useVideoElementRefContext = () =>
  useContext(VideoElementRefContext);

export const VideoElementRefProvider = ({
  children,
  initialValue = null,
  videoElementRef: externalRef
}) => {
  const internalRef = useRef(initialValue);
  // An externally owned ref lets the host app read/control the video element.
  const videoElementRef = externalRef ?? internalRef;

  return (
    <VideoElementRefContext.Provider value={videoElementRef}>
      {children}
    </VideoElementRefContext.Provider>
  );
};

VideoElementRefProvider.propTypes = {
  children: PropTypes.node,
  initialValue: PropTypes.any,
  videoElementRef: PropTypes.shape({ current: PropTypes.any })
};
